<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="商户代码">
                    <c-input name="saas_id" maxlength="10"></c-input>
                </m-search-item>
                <m-search-item label="商户简码">
                    <c-input name="saas_brief_code" maxlength="3"></c-input>
                </m-search-item>
                <m-search-item label="商户名称">
                    <c-input name="saas_full_name" maxlength="50"></c-input>
                </m-search-item>
                <m-search-item label="通联账户类型">
                    <c-select name="allinpay_saas_type" :options="ALLINPAY_SAAS_TYPE"></c-select>
                </m-search-item>
                <m-search-item label="版本">
                    <c-select name="version_id" :options="versionOptions"></c-select>
                </m-search-item>
                <m-search-item label="状态">
                    <c-checkbox-group name="saas_states" :options="disableEnableDic"></c-checkbox-group>
                </m-search-item>
                <m-search-item label="联系人">
                    <c-input name="saas_contact_person" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="联系电话">
                    <c-input name="saas_contact_phone" maxlength="50"></c-input>
                </m-search-item>
                <m-search-item label="地址">
                    <c-input name="saas_address" maxlength="50"></c-input>
                </m-search-item>
                <m-search-item label="最近活跃时间">
                    <c-select name="last_active_day" :options="dateRangDic"></c-select>
                </m-search-item>
                <m-search-item label="最近登陆时间">
                    <c-select name="last_login_day" :options="dateRangDic"></c-select>
                </m-search-item>
                <m-search-item label="注册来源" colspan="2">
                    <c-checkbox-group name="register_sources" :options="registerSourceDic"></c-checkbox-group>
                </m-search-item>
                <m-search-item label="授权状态">
                    <c-checkbox-group name="authExpStates">
                        <c-checkbox value="1">未到期</c-checkbox>
                        <c-checkbox value="2">已到期</c-checkbox>
                    </c-checkbox-group>
                </m-search-item>
                <m-search-item label="创建时间" colspan="2">
                    <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                </m-search-item>
                <m-search-item label="授权到期时间" colspan="2">
                    <c-datetime range start-name="exp_start_date" end-name="exp_end_date"></c-datetime>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_saas_add')" prepend-icon="tf-add" @click="$refs.saasEdit.open()">
                    开通新商户
                </c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="商户代码"
                        name="saas_id"
                        width="70"
                        fixed="left"
                >
                </c-table-column>

                <c-table-column
                        label="商户简码"
                        name="saas_brief_code"
                        width="70"
                >
                </c-table-column>

                <c-table-column
                        label="商户简称"
                        name="saas_name"
                        width="180"
                >
                </c-table-column>

                <c-table-column
                        label="商户名称"
                        name="saas_full_name"
                        width="180"
                >
                </c-table-column>

                <c-table-column
                        label="商户评分"
                        name="saas_score"
                        width="70"
                >
                </c-table-column>

                <c-table-column
                        label="通联账户类型"
                        name="member_type"
                        width="95"
                >
                    <template #default="{data}">
                        <c-state async tag dict="ALLINPAY_SAAS_TYPE" :value="data.allinpay_saas_type"></c-state>
                    </template>
                </c-table-column>


                <c-table-column
                        label="版本"
                        name="version_name"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="竞价堂账号"
                        name="jldhs_account"
                        width="150"
                >
                    <template #default="{data}">
                        <span v-if="data.is_open_jldhs == 1" style="color:green">[开]</span>
                        <span v-else style="color:gray">[关]</span>
                        {{data.jldhs_account||'-'}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="联系人"
                        name="saas_contact_person"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="联系电话"
                        name="saas_contact_phone"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="系统管理员"
                        width="155"
                >
                    <template #default="{data}">
                        <span v-if="data.manage_user_name" style="color:black">
                            {{data.manage_user_name}}({{data.manage_user_phone}})
                        </span>
                        <span v-else></span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="商户地址"
                        name="saas_address"
                        width="300"
                >
                </c-table-column>

                <c-table-column
                        label="授权开始时间"
                        name="auth_start_date"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="授权到期时间"
                        name="auth_exp_date"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="授权剩余天数"
                        name="remaining_effective_days"
                        width="100"
                >
                    <template #default="{data}">
                        <b v-if="data.remaining_effective_days <= 0" style="color:red">已到期</b>
                        <b v-else-if="data.remaining_effective_days <= 10"
                           style="color:darkorange">{{ data.remaining_effective_days }}</b>
                        <b v-else style="color:green">{{ data.remaining_effective_days }}</b>
                    </template>
                </c-table-column>

                <c-table-column
                        label="员工账户数"
                        name="account_count"
                        width="90"
                >
                    <template #default="{data}">
                        <b style="color:blue">{{ data.use_account_count }}</b>
                        /
                        <strong>{{ data.max_account_count }}</strong>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="130"
                ></c-table-column>

                <c-table-column
                        label="注册来源"
                        name="register_source"
                        width="85"
                >
                    <template #default="{data}">
                        <c-state tag dict="registerSourceDic" :value="data.register_source"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="最近活跃时间"
                        name="last_active_time"
                        width="130"
                >
                </c-table-column>

                <c-table-column
                        label="最近登陆时间"
                        name="last_login_time"
                        width="130"
                >
                </c-table-column>

                <c-table-column
                        label="创建人"
                        name="create_user_realname"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="状态"
                        name="saas_state"
                        width="80"
                >
                    <template #default="{data}">
                        <c-switch v-if="auth('b_saas_state')" v-model="data.saas_state" :state-value="[1, 2]"
                                  :state-text="['启用','禁用']"
                                  @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                        <c-state v-else dict="disableEnableDic" :value="data.saas_state"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="180"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_saas_allinpay_bind_phone') && data.allinpay_member_state == 0" icon="tf-phone" @click="$refs.allinpayAccountEdit.open(data)">通联绑定手机</c-table-button>
                        <c-table-button v-if="auth('b_channel_config')" icon="tf-setting" @click="saasChannelConfig(data)">同售渠道配置</c-table-button>
                        <c-table-button v-if="auth('b_saas_edit')" icon="tf-edit" @click="$refs.saasEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_open_jldhs')" icon="tf-setting" @click="$refs.jldhsAccountEdit.open(data)">配置竞价堂账号</c-table-button>
                        <c-table-button v-if="auth('b_edit_saas_score')" icon="tf-edit" @click="$refs.saasScoreEdit.open(data)">编辑商户评分</c-table-button>
                        <c-table-button v-if="auth('b_saas_auth')" icon="tf-auth" @click="$refs.saasAuthConfig.open(data , 0)">电脑端权限</c-table-button>
                        <c-table-button v-if="auth('b_saas_auth')" icon="tf-auth" @click="$refs.saasAuthConfig.open(data , 1)">移动端权限</c-table-button>
                        <c-table-button v-if="auth('b_saas_edit_version')" icon="tf-edit" @click="$refs.saasEditVersion.open(data)">修改版本信息</c-table-button>
                        <c-table-button v-if="auth('b_saas_reset_pwd')" icon="tf-reset-password" @click="resetSaasPwd(data)">重置管理员密码</c-table-button>
                        <c-table-button v-if="auth('b_saas_delete') && data.saas_state == 2" icon="tf-trash" color="red" @click="removeSaas(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--创建/编辑商户信息弹窗-->
            <saas-edit ref="saasEdit" @resolve="$refs.list.update()"></saas-edit>
            <!--编辑商户版本信息弹窗-->
            <saas-edit-version ref="saasEditVersion" @resolve="$refs.list.update()"></saas-edit-version>
            <!--商户权限配置信息弹窗-->
            <saas-auth-config ref="saasAuthConfig"></saas-auth-config>
            <!--商户主账号的通联账号编辑信息弹窗-->
            <allinpay-account-edit ref="allinpayAccountEdit" @resolve="$refs.list.update()"></allinpay-account-edit>
            <!--编辑竞价堂信息弹窗-->
            <jldhs-account-edit ref="jldhsAccountEdit" @resolve="$refs.list.update()"></jldhs-account-edit>
            <!--编辑评分弹窗-->
            <saas-score-edit ref="saasScoreEdit" @resolve="$refs.list.update()"></saas-score-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'

import saasEdit from "@/pages/saas/saas_edit.vue";
import saasEditVersion from "@/pages/saas/saas_edit_version.vue";
import saasAuthConfig from "@/pages/saas/saas_auth_config.vue";
import allinpayAccountEdit from "@/pages/saas/allinpay_account_edit.vue";
import jldhsAccountEdit from "@/pages/saas/jldhs_account_edit.vue";
import saasScoreEdit from "@/pages/saas/saas_score_edit.vue";

export default {
    components: {
        saasEdit,
        saasEditVersion,
        saasAuthConfig,
        allinpayAccountEdit,
        jldhsAccountEdit,
        saasScoreEdit
    },
    computed: {
        ...mapState(['saasTypeDic', 'vipDic', 'disableEnableDic', 'salesStateDic', 'dateRangDic', 'registerSourceDic']),
        ...asyncMapState(['ALLINPAY_SAAS_TYPE'])
    },
    props: {
        type: String
    },

    data() {
        return {
            versionOptions: []//可选版本列表
        }
    },

    mounted() {
        this.initSaasVersion();
        this.searchHandle();
    },

    methods: {
        /*******加载版本下拉框数据*****************/
        initSaasVersion() {
            this.request({
                url: '/sys_saas/version/list',
                data: {},
                success: data => {
                    this.versionOptions = data.map(item => {
                        return {
                            name: item.version_name,
                            value: item.id,
                            data: item
                        }
                    })
                }
            })
        },
        /********搜索************/
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            this.$refs.list.load({
                url: '/sys_saas/list',
                data
            });
        },
        /*********同售渠道配置**********/
        saasChannelConfig(data) {
            this.globalDialog('saasChannelConfig', {data: data}, () => {
                this.$refs.list.update();
            });
        },
        /******商户启禁用*********/
        stateHandle(state, next, data) {
            //启用用户前，如果当前商家（主账号）尚未创建通联账户，则提示需要先创建通联账号
            if (data.saas_state == 2 && data.allinpay_member_state == 0) {
                this.$confirm({
                    message: '商户【' + data.saas_id + '-' + data.saas_name + '】关联的通联账号尚未完成手机号绑定，不允许启用，请点击商家列表点击“通联绑定手机”按钮进行绑定操作',
                    buttonName: '知道了',
                    cancelButton: false,
                    resolve: () => {
                    }
                });
                return;
            } else {
                this.request({
                    url: '/sys_saas/update_state',
                    data: {
                        saas_id: data.saas_id,
                        saas_state: state ? 2 : 1
                    },
                    success: () => {
                        this.$message({
                            message: '操作成功',  // 提示内容,
                            type: 'success'
                        });
                        next();
                    }
                });
            }
        },
        /******商户启禁用竞价堂账号*********/
        openJldhs(state, next, data) {
            //启用用户前，如果当前商家（主账号）尚未创建通联账户，则提示需要先创建通联账号
            if (data.saas_state == 2 && data.allinpay_member_state == 0) {
                this.$confirm({
                    message: '商户【' + data.saas_id + '-' + data.saas_name + '】关联的通联账号尚未完成手机号绑定，不允许启用，请点击商家列表点击“通联绑定手机”按钮进行绑定操作',
                    buttonName: '知道了',
                    cancelButton: false,
                    resolve: () => {
                    }
                });
                return;
            } else {
                this.request({
                    url: '/sys_saas/update_state',
                    data: {
                        saas_id: data.saas_id,
                        saas_state: state ? 2 : 1
                    },
                    success: () => {
                        this.$message({
                            message: '操作成功',  // 提示内容,
                            type: 'success'
                        });
                        next();
                    }
                });
            }
        },

        /******重置管理员密码*******/
        resetSaasPwd(data) {
            this.$confirm({
                message: '确认重置商户【' + data.saas_id + ' / ' + data.saas_name + '】的管理员密码吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/sys_saas/reset_saas_pwd',
                        data: {saas_id: data.saas_id},
                        loading: true,
                        success: result => {
                            this.$confirm({
                                message: result,
                                buttonName: '知道了',
                                cancelButton: false,
                                resolve: () => {
                                }
                            });
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        /******删除商户***********/
        removeSaas(data) {
            this.$confirm({
                message: '确认删除商户代码【' + data.saas_id + '】？删除后不可恢复',  // 提示内容,
                // buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/sys_saas/delete',
                        data: {saas_id: data.saas_id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>